import { render, staticRenderFns } from "./OrganisationView.vue?vue&type=template&id=398b936f&scoped=true"
import script from "./OrganisationView.vue?vue&type=script&lang=js"
export * from "./OrganisationView.vue?vue&type=script&lang=js"
import style0 from "./OrganisationView.vue?vue&type=style&index=0&id=398b936f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b936f",
  null
  
)

export default component.exports